export { default as InfoRow } from './InfoRow';
